/**
 * Document-type grouping helpers.
 *
 * A document type is "primary" when its `is_primary` (or `isPrimary`) flag is set. Primary types are
 * surfaced first, under a "PRIMARY DOCUMENTS" heading, in every document-type picker across the app;
 * the rest fall under "SECONDARY DOCUMENTS".
 */

export const isPrimaryDocType = (dt) => dt?.isPrimary === true || dt?.is_primary === true;

// A company document type (trade licence, ...) is kept on the client, never synced to an employee.
export const isOrganizationDocType = (docTypes = [], code) => docTypes.some(
  (dt) => (dt.code || dt.id) === code && (dt.holder_type || dt.holderType) === 'ORGANIZATION'
);

// Split a doc-type list into { primary, secondary }, preserving the original order within each group.
export const splitDocTypes = (docTypes = []) => ({
  primary: docTypes.filter(isPrimaryDocType),
  secondary: docTypes.filter((dt) => !isPrimaryDocType(dt)),
});
